import React from 'react'

// "Blister Pack" badge shown next to a blister patient's name (patient card, search, missed-delivery
// pop-up), so the driver sees at a glance that this patient's medication comes as a blister pack.
export const BlisterPackBadge = ({ className = '', count = null }) => (
	<span
		className={`inline-flex items-center gap-1 h-6 pl-1.5 pr-2 shrink-0 rounded-full border border-teal-300 bg-teal-50 text-teal-800 text-xs font-semibold normal-case whitespace-nowrap ${className}`}
		title="Blister pack patient"
	>
		<svg className="w-3.5 h-3.5 shrink-0" viewBox="0 0 16 16" fill="none" aria-hidden="true">
			<rect x="1.5" y="1.5" width="13" height="13" rx="2.5" stroke="currentColor" strokeWidth="1.4" />
			<circle cx="5.5" cy="5.5" r="1.6" fill="currentColor" />
			<circle cx="10.5" cy="5.5" r="1.6" fill="currentColor" />
			<circle cx="5.5" cy="10.5" r="1.6" fill="currentColor" />
			<circle cx="10.5" cy="10.5" r="1.6" fill="currentColor" />
		</svg>
		Blister Pack
		{count !== null && (
			<span className="ml-0.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-teal-600 text-white text-[11px] font-semibold">
				{count}
			</span>
		)}
	</span>
)

export default BlisterPackBadge
